module.exports = __webpack_public_path__ + "img/rupee.2b913d74.svg";